export enum TemplateCheckoutEnum {
  CLASSICO = 'classico',
  MINIMALISTA = 'minimalista',
}
